import { sendPost } from '@/utils/request.js';
import { getUserCenterParams, unionFlag } from './../utils';
import { mySendPost, transformCities } from './addressV2';
// 获取城市列表
function getCityData(data) {
  const url = "/location/area/getcitylist";
  return mySendPost(url, data).then(transformCities);
}

// 获取公告
function getNotice(data) {
  const url = '/mall/bff/shop/notice/content';
  return sendPost(url, data, false, true);
}

// 获取快速搜索
function getQuickSearch(data) {
  // const url = '/search/quick';
  const url = '/search/searchContract/quick/v2';
  return sendPost(url, data);
}

// 获取搜索词链
function getSearchUrl(data) {
  const url = '/word/super';
  return sendPost(url, data);
}

// 查询是否敏感词
function getSensitiveUrl(data) {
  const url = '/word/sensitive';
  return sendPost(url, data);
}


// 获取新工会头部数据
function getFindByUnion(data) {
  const url = '/cms/front/union/findByUnion';
  return sendPost(url, data, false, true);
}


// // 获取登录状态
// function getLoginStatus() {
//   let params = {
//     union: '',
//     unionFlag: 0,
//   };
//   let union = unionFlag() || sessionStorage.getItem('dffl_union');

//   if(union){
//     params = {
//       union,
//       unionFlag: 1,
//     };
//   }
//   const url = '/user/checkLogin';
//   return sendPost({ url, params, baseURL: false, applicationType: false });
// }

// 获取登录状态
function getLoginStatus(data) {
  const url = '/user/front/user/checkLogin';
  return sendPost(url, data, false, true, "get");
}

// 新版获取工会信息
function getCompanyInfo(data) {
  const url = '/companydata/gateway/company/info';
  return sendPost(url, data, false, true, "get");
}

// // 获取登录状态
// function getLoginOut() {
//   let params = {
//     union: '',
//     unionFlag: 0,
//   };
//   let union = unionFlag() || sessionStorage.getItem('dffl_union');
//   if(union){
//     params = {
//       union,
//       unionFlag: 1,
//     };
//   }
//   const url = '/user/loginOut';
//   return sendPost({ url, params, baseURL: false, applicationType: false });
// }

// 登出
function getLoginOut(data) {
  const url = '/user/front/user/logout';
  return sendPost(url, data, false, true, "get");
}

// 获取工会菜单
function getFindUsableList(data) {
  const url = '/cms/front/ecms/getPcMallNavList';
  return sendPost(url, data, false, true);
}

// 获取工会logo及客服信息
function getUnionLogoAndPhone(data) {
  const url = '/companydata/front/head/getPcHeadInfo';
  return sendPost(url, data, false, true);
}

//
function getIsNewUnion(data) {
  const url = '/mallUnion/union/isNewUnion';
  return sendPost(url, data);
}

// 获取老公会通知信息
function getMessage(data) {
  const url = '/user/front/component/message';
  return sendPost(url, data, false, true);
}

function getDefaultAddress(data) {
  const url = '/trade/addressContract/getDefaultAddress';
  return sendPost(url, data);
}

// 保留城市信息
function saveCity(data) {
  const url = '/position/external/currentCityUpdate';
  return sendPost(url, getUserCenterParams(data));
}

// 保留语言选择
function saveLanguage(data) {
  const url = '/user/front/user/editMyInfo';
  return sendPost(url, data, false, true);
}

export default {
  getCityData,
  getNotice,
  getQuickSearch,
  getFindByUnion,
  getLoginStatus,
  getFindUsableList,
  getUnionLogoAndPhone,
  getIsNewUnion,
  getMessage,
  getDefaultAddress,
  getLoginOut,
  getSearchUrl,
  getSensitiveUrl,
  saveCity,
  saveLanguage,
  getCompanyInfo,
};
